import { Document, Image, Page, Text, View } from '@react-pdf/renderer'

import { TYPES } from '~/constants'
import { cls, fmtAddress } from '~/lib'
import type { ReportPdfOptions } from '~/models'
// import { PdfListingMeta } from './components'
import type { Client, Listing } from '~/models'
import PdfBadge from './badge'
import PdfListingMeta from './listing-meta'
import {
  PdfDisclaimersPage,
  ReportPdfMapPage,
  //   ReportPdfMapPage,
  ReportPdfTitlePage,
} from './pages'
import { tw } from './tw'
import { getReportListingName } from './utils'

export default function ReportSummaryPdf({
  client,
  title,
  listings,
  pdfOptions,
}: {
  client: Client
  title: string
  listings: Listing[]
  pdfOptions: ReportPdfOptions
}) {
  // function getMaxSubstringLength(value: string, maxLength: number) {
  //   if (value.length <= maxLength) return value.length
  //   const lastSpaceIndex = value.lastIndexOf(' ', maxLength)
  //   if (lastSpaceIndex === -1) return maxLength
  //   return lastSpaceIndex
  // }
  return (
    <Document title={title}>
      {pdfOptions.showTitlePage && (
        <ReportPdfTitlePage
          title={title}
          listings={listings}
          pdfOptions={pdfOptions}
          orientation="landscape"
          client={client}
        />
      )}
      {pdfOptions.showMapPage && (
        <ReportPdfMapPage
          listings={listings}
          pdfOptions={pdfOptions}
          orientation="landscape"
        />
      )}
      <Page size="LETTER" style={tw('p-8 font-sans')} orientation="landscape">
        <View style={tw('flex flex-col gap-6')}>
          {listings.map((listing, index) => {
            return (
              <View key={listing.id} break={false} wrap={false}>
                <View style={tw('flex flex-row gap-6')}>
                  <View style={tw('w-3/12')}>
                    {(listing.images || []).length > 0 ? (
                      <View
                        style={tw(
                          'relative flex h-[160px] items-center justify-center overflow-hidden rounded-sm bg-slate-100'
                        )}>
                        <Image
                          src={`${listing.images![0].thumbnail_url}?bust=${new Date().getTime()}`}
                        />
                        <View
                          style={tw(
                            'absolute left-0.5 top-0.5 flex h-6 min-w-[1.5rem] flex-row items-center justify-center rounded-sm bg-white px-1'
                          )}>
                          <Text style={tw('pb-1 text-xs leading-none')}>
                            {index + 1}
                          </Text>
                        </View>
                      </View>
                    ) : (
                      <View style={tw('h-[160px] rounded-sm bg-slate-100')} />
                    )}
                  </View>
                  <View style={tw('w-9/12')}>
                    <View style={tw('mb-1')}>
                      <View
                        style={tw(
                          'mb-1 flex w-full flex-row items-center justify-between gap-6'
                        )}>
                        <View style={tw('flex flex-row items-start gap-2')}>
                          <Text
                            style={tw('font-heading text-xl leading-tight')}>
                            {getReportListingName(listing)}
                          </Text>
                        </View>

                        <View style={tw('flex flex-row items-center gap-4')}>
                          <PdfBadge
                            className={cls(
                              // 'absolute top-3 left-3 text-white',
                              'py-2 text-white',
                              listing.type === 'sale' && 'bg-[#0284c7]',
                              listing.type === 'lease' && 'bg-[#c026d3]',
                              listing.type === 'sale/lease' && 'bg-[#4338ca]'
                            )}>
                            For {TYPES[listing.type]}
                          </PdfBadge>
                        </View>
                      </View>
                      <View
                        style={tw(
                          'flex w-full flex-row justify-between gap-6'
                        )}>
                        <Text style={tw('font-sans text-base text-muted')}>
                          {fmtAddress(listing.property)}
                        </Text>
                      </View>
                    </View>
                    <PdfListingMeta listing={listing} pdfOptions={pdfOptions} />
                  </View>
                </View>
              </View>
            )
          })}
        </View>
      </Page>
      <PdfDisclaimersPage
        client={client}
        pdfOptions={pdfOptions}
        orientation="landscape"
      />
    </Document>
  )
}
